import ActorDetail from './ActorDetail';

export default ActorDetail;
